import { connect } from 'react-redux';
import * as R from 'ramda';

import {
  getFilterIdentifierCount,
  resetCardFilters,
} from 'feature/loading-management/filters/store/filtersSlice';
import CardsPanel from './CardsPanel';
import {
  getActiveAuthSequencingTab,
  getAuthorizationSequencingCards,
  getCurrentSelection,
  getListTabCounts,
  getStoreValueByProp,
  setActiveAuthSequencingTab,
  setFiltersOpen,
} from '../store/authorizationSequencingSlice';

const mapState = R.applySpec({
  activeAuthSequencingTab: getActiveAuthSequencingTab,
  authorizationSequencingPending: getStoreValueByProp(['authorizationSequencingPending']),
  cardsCount: getAuthorizationSequencingCards,
  currentSelection: getCurrentSelection,
  filterIdentifierCount: getFilterIdentifierCount,
  filtersOpen: getStoreValueByProp(['filtersOpen']),
  listTabCounts: getListTabCounts,
});

const mapDispatch = {
  resetCardFilters,
  setActiveAuthSequencingTab,
  setFiltersOpen,
};

export default connect(mapState, mapDispatch)(CardsPanel);
